import React, { FC } from 'react';

const HowCanWeHelp: FC = () => {
  return (
    <div className='mt-24 text-left md:mt-32 lg:mt-40 lg:grid lg:justify-items-center'>
      <div className='flex text-lg font-semibold text-brands-chop lg:mx-auto'>Questions</div>
      <h3 className='mt-3 section-header lg:text-center'>How Can We Help?</h3>
      <div className='mt-2 body-paragraph lg:text-center'>
        If you&apos;re wondering what camera equipment you&apos;ll need, how to launch services
        online, or how hosting works, we have answers! Start with these, and dig in to our free
        guides and trainings for even more about online ministry.
      </div>
    </div>
  );
};

export default HowCanWeHelp;
